import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';
import { UpdateSensorTagListDataModel } from '../models';
import { updateSensorListTagListToPayload } from '../mappers';

const getUrl = (host: string) => {
  return `${host}/sensors/tags`;
};

export const UpdateSensorTagList = async ({
  host,
  token,
  data,
}: {
  host: string;
  token: string;
  data: UpdateSensorTagListDataModel[];
}): Promise<void> => {
  try {
    const url = getUrl(host);

    const mappedData = updateSensorListTagListToPayload(data);

    const options: AxiosRequestConfig = {
      url,
      method: 'PUT',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
      data: { data: mappedData },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
